import React from 'react';
import * as PropTypes from 'prop-types';
import {
  Wrapper,
  Title,
  Co2Label,
  DetailsWrapper,
  TitleWeak,
} from './elements';
import Act36 from 'dc/Act36';

type ACI001Props = {
  className?: string;
  activityIcon: string;
  activityUnavailable: boolean;
  color: string;
  title: string;
  icon: string;
  value: number | string;
};

function ACI001({
  className,
  activityIcon,
  activityUnavailable,
  color,
  title,
  icon,
  value,
}: ACI001Props) {
  return (
    <Wrapper className={className}>
      <Act36 icon={activityIcon} />
      <DetailsWrapper>
        {activityUnavailable ? (
          <TitleWeak color={color}>{title}</TitleWeak>
        ) : (
          <Title color={color}>{title}</Title>
        )}
        <Co2Label
          icon={icon || 'icon-leaf'}
          $iconColor={color}
          color={activityUnavailable && '#5E6372'}
        >
          {value}
        </Co2Label>
      </DetailsWrapper>
    </Wrapper>
  );
}

ACI001.propTypes = {
  activityUnavailable: PropTypes.bool,
  className: PropTypes.string,
  title: PropTypes.node,
  value: PropTypes.node,
  icon: PropTypes.string,
  color: PropTypes.string,
  activityIcon: PropTypes.string,
};

export default ACI001;
